import { useContext, useEffect } from 'react'

import { Route, Redirect } from 'react-router-dom'
import DashboardContext from '../../Context'
import Layout from '../layout'
import ComponetMinger from './ComponetMinger'

/**
 * اگر کاربر لاگین باشد کامپوننت نمایش داده می شود 
 * اگر کاربر لاگین نباشد  به صفحه ورود ارسال می شود
 */
export default function Authentication({ component: Component, ...rest }) {

    const { islogin, handelPatch } = useContext(DashboardContext)

    useEffect(() => {
        handelPatch(rest.path)
        return () => {

        };
    }, [rest.path]);

    return (

        <Route
            {...rest}
            render={props =>
                islogin ? (
                    <Layout>
                        <ComponetMinger {...props} url={rest.path} />
                    </Layout>
                ) : (
                    <Redirect to={{ pathname: "/login", state: { status: 302 } }} />
                )
            }
        />
    )
}
